import { Spinner } from '@tempo-io/sui-spinner';

export const Loading = ({ isLoading, size = 40 }: { isLoading: boolean; size?: number }) => {
  if (!isLoading) return null;

  return (
    <div className="flex items-center justify-center h-full" data-testid="fim3-loading">
      <Spinner size={size} />
    </div>
  );
};
